import cn from 'classnames';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import SimpleCheckbox from '../SimpleCheckbox';
import { AnalyticsSpinner } from '../Spinner/AnalyticsSpinner';

import styles from './MultipleSelect.module.scss';

function MultipleSelect(props) {
  const [query, setQuery] = useState('');

  const search = (value = '') => {
    setQuery(value.toLowerCase());
  };

  const select = (selected) => {
    if (props.onChange) {
      props.onChange(selected);
    }
  };

  const handleCheck = (value, checked) => {
    if (checked) {
      select([...props.selected, value]);
    } else {
      const selected = props.selected.filter((selectedValue) => selectedValue !== value);
      select(selected);
    }
  };

  const selectAll = () => {
    const allValues = props.options.filter((option) => !option.disabled).map((option) => option.value);
    select(allValues);
  };

  const clearAll = () => {
    select([]);
  };

  const renderOptions = () => {
    const { selected, options, sort } = props;

    if (!options?.length) {
      return <AnalyticsSpinner />;
    }

    const opts = options.slice();
    if (sort) {
      opts.sort((a, b) => a.label.localeCompare(b.label));
    }

    return opts
      .filter((option) => option.label.toLowerCase().indexOf(query) >= 0)
      .map((option, index) => (
        <SimpleCheckbox
          key={index}
          value={option.value}
          label={option.label}
          checked={selected.includes(option.value)}
          onChange={(checked) => handleCheck(option.value, checked)}
          disabled={option.disabled}
        />
      ));
  };

  return (
    <>
      <div className={styles.panel}>
        <span onClick={selectAll}>Select All</span>
        <span onClick={clearAll}>Clear All</span>
      </div>

      <div className={cn(styles.search, 'search')}>
        <input type="text" placeholder="Search" onChange={(event) => search(event.target.value)} value={query} />
        <span className={query === '' ? 'ic-search' : 'ic-close'} onClick={() => search('')} />
      </div>

      <div className={styles.options}>{renderOptions()}</div>
    </>
  );
}

export default MultipleSelect;

MultipleSelect.defaultProps = {
  options: [],
  selected: [],
  sort: false,
};

MultipleSelect.propTypes = {
  options: PropTypes.array.isRequired,
  selected: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  sort: PropTypes.bool,
};
